export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5670.da6a7c7d.jpg";